import axios from ".././../axios-interceptor";
import { EVENT_CLASSIFICATION_AESI, EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_DOESNT_MEETS_CASE, EVENT_MEETS_CASE } from "../../utilities";
import { base_url } from "../../utilities";
import {SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT, SUBJECT_STATUS_ON_STUDY, SUBJECT_STATUS_OFF_STUDY} from '../../utilities';
 


export const toggleOn = () => {
    return {
      type: 'TOGGLE',
      
    };
  };
  export const getEventFlag = (data) => {
    return (dispatch) => {
          dispatch({
            type:  GET_EVENT_FLAG,
            payload: data,
        
        });
    };
  };


export const LOGIN_DATA_SUCCESS = 'LOGIN_DATA_SUCCESS';
export const LOGIN_DATA_FAILURE = 'LOGIN_DATA_FAILURE';

export const GET_ZONE_DATA_SUCCESS = 'GET_ZONE_DATA_SUCCESS';
export const GET_ZONE_DATA_FAILURE = 'GET_ZONE_DATA_FAILURE';

export const GET_STATE_DATA_SUCCESS = 'GET_STATE_DATA_SUCCESS';
export const GET_STATE_DATA_FAILURE = 'GET_STATE_DATA_FAILURE';

export const GET_CITY_DATA_SUCCESS = 'GET_CITY_DATA_SUCCESS';
export const GET_CITY_DATA_FAILURE = 'GET_CITY_DATA_FAILURE';

export const GET_SITE_DATA_SUCCESS = 'GET_SITE_DATA_SUCCESS';
export const GET_SITE_DATA_FAILURE = 'GET_SITE_DATA_FAILURE';

export const GET_ACTION_TAKEN_SUCCESS = 'GET_ACTION_TAKEN_SUCCESS';
export const GET_ACTION_TAKEN_FAILURE = 'GET_ACTION_TAKEN_FAILURE';

export const GET_STUDIES_DATA_SUCCESS = 'GET_STUDIES_DATA_SUCCESS';
export const GET_STUDIES_DATA_FAILURE = 'GET_STUDIES_DATA_FAILURE';

export const GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS = 'GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS';
export const GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE = 'GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE';

export const GET_STUDY_DATA_SUCCESS = 'GET_STUDY_DATA_SUCCESS';
export const GET_STUDY_DATA_FAILURE = 'GET_STUDY_DATA_FAILURE';

export const GET_DOSE_ADMINISTRATION = 'GET_DOSE_ADMINISTRATION';
export const GET_DOSE_ADMINISTRATION_FAILURE = 'GET_DOSE_ADMINISTRATION_FAILURE';
export const GET_SITE_ADMINISTRATION = 'GET_SITE_ADMINISTRATION';
export const GET_SITE_ADMINISTRATION_FAILURE = 'GET_SITE_ADMINISTRATION_FAILURE';
export const GET_SUBJECT_LIST = 'GET_SUBJECT_LIST';
export const GET_SUBJECT_LIST_FAILURE = 'GET_SUBJECT_LIST_FAILURE';
export const GET_SUBJECT_COUNTS = 'GET_SUBJECT_COUNTS';
export const GET_SUBJECT_COUNTS_FAILURE = 'GET_SUBJECT_COUNTS_FAILURE';

export const ADD_NEW_ADVERSE_EVENT_SUCCESS = 'ADD_NEW_ADVERSE_EVENT_SUCCESS';
export const ADD_NEW_ADVERSE_EVENT_FAILURE = 'ADD_NEW_ADVERSE_EVENT_FAILURE';

export const GET_QR_STUDY_INFO = 'GET_QR_STUDY_INFO';
export const GET_QR_STUDY_INFO_FAILURE = 'GET_QR_STUDY_INFO_FAILURE';

export const GET_MR_STUDY_INFO = 'GET_MR_STUDY_INFO';
export const GET_MR_STUDY_INFO_FAILURE = 'GET_MR_STUDY_INFO_FAILURE';

export const GET_STUDY_INFO = 'GET_STUDY_INFO';
export const GET_STUDY_INFO_FAILURE = 'GET_STUDY_INFO_FAILURE';

export const GET_PIDASHBOARD_CHART_DATA = 'GET_PIDASHBOARD_CHART_DATA';
export const GET_PIDASHBOARD_CHART_DATA_FAILURE = 'GET_PIDASHBOARD_CHART_DATA_FAILURE';

export const GET_QR_STUDYLIST_DATA_SUCCESS = 'GET_QR_STUDYLIST_DATA_SUCCESS';
export const GET_QR_STUDYLIST_DATA_FAILURE = 'GET_QR_STUDYLIST_DATA_FAILURE';

export const GET_MR_STUDYLIST_DATA_SUCCESS = 'GET_MR_STUDYLIST_DATA_SUCCESS';
export const GET_MR_STUDYLIST_DATA_FAILURE = 'GET_MR_STUDYLIST_DATA_FAILURE';

export const GET_QRSUBJECT_COUNTS_SUCCESS= 'GET_QRSUBJECT_COUNTS_SUCCESS';
export const GET_QRSUBJECT_COUNTS_FAILURE = 'GET_QRSUBJECT_COUNTS_FAILURE';

export const GET_QRSUBJECTS_RELATED_COUNTS_SUCCESS= 'GET_QRSUBJECTS_RELATED_COUNTS_SUCCESS';
export const GET_QRSUBJECTS_RELATED_COUNTS_FAILURE = 'GET_QRSUBJECTS_RELATED_COUNTS_FAILURE';

export const GET_MSSUBJECT_DB_COUNTS_SUCCESS= 'GET_MSSUBJECT_DB_COUNTS_SUCCESS';
export const GET_MSSUBJECT_DB_COUNTS_FAILURE = 'GET_MSSUBJECT_DB_COUNTS_FAILURE';

export const GET_QRSUBJECT_LIST_SUCCESS ="GET_QRSUBJECT_LIST_SUCCESS"
export const GET_QRSUBJECT_LIST_FAILURE ="GET_QRSUBJECT_LIST_FAILURE"

export const GET_QRSUBJECT_REVIEW_LIST_SUCCESS ="GET_QRSUBJECT_REVIEW_LIST_SUCCESS"
export const GET_QRSUBJECT_REVIEW_LIST_FAILURE ="GET_QRSUBJECT_REVIEW_LIST_FAILURE"

export const GET_ZONE_COUNTS_DATA = 'GET_ZONE_COUNTS_DATA';
export const GET_ZONE_COUNTS_DATA_FAILURE = 'GET_ZONE_COUNTS_DATA_FAILURE';

export const GET_ACTION_TAKEN_FOR_AE_SUCCESS = 'GET_ACTION_TAKEN_FOR_AE_SUCCESS';
export const GET_ACTION_TAKEN_FOR_AE_FAILURE = 'GET_ACTION_TAKEN_FOR_AE_FAILURE';

export const GET_EVENT_DETAILS_SUCCESS = 'GET_EVENT_DETAILS_SUCCESS';
export const GET_EVENT_DETAILS_FAILURE = 'GET_EVENT_DETAILS_FAILURE';

export const GET_SUBJECT_DETAILS_SUCCESS = 'GET_SUBJECT_DETAILS_SUCCESS';
export const GET_SUBJECT_DETAILS_FAILURE = 'GET_SUBJECT_DETAILS_FAILURE';

export const GET_ALL_SUBJECTS_TO_ADD_AE_SUCCESS = 'GET_ALL_SUBJECTS_TO_ADD_AE_SUCCESS';
export const GET_ALL_SUBJECTS_TO_ADD_AE_FAILURE = 'GET_ALL_SUBJECTS_TO_ADD_AE_FAILURE';

export const GET_MARKETING_HEAD_DATA = 'GET_MARKETING_HEAD_DATA';
export const GET_MARKETING_HEAD_DATA_FAILURE = 'GET_MARKETING_HEAD_DATA_FAILURE';
export const GET_QRDASHBOARD_LIST_SUCCESS ='GET_QRDASHBOARD_LIST_SUCCESS';
export const GET_QRDASHBOARD_LIST_FAILURE ='GET_QRDASHBOARD_LIST_FAILURE';

export const GET_MARKETING_HEAD_STUDY_DATA = "GET_MARKETING_HEAD_STUDY_DATA"
export const GET_MARKETING_HEAD_STUDY_DATA_FAILURE = "GET_MARKETING_HEAD_STUDY_DATA_FAILURE"

export const GET_MARKETING_HEAD_STUDY_SITES_DATA = "GET_MARKETING_HEAD_STUDY_SITES_DATA"
export const GET_MARKETING_HEAD_STUDY_SITES_DATA_FAILURE = "GET_MARKETING_HEAD_STUDY_SITES_DATA_FAILURE"

export const GET_MARKETING_STAFF_LIST = "GET_MARKETING_STAFF_LIST"
export const GET_MARKETING_STAFF_LIST_FAILURE = "GET_MARKETING_STAFF_LIST_FAILURE"

export const GET_REJECTED_EVENTS_LIST = "GET_REJECTED_EVENTS_LIST";
export const GET_REJECTED_EVENTS_LIST_FAILURE = "GET_REJECTED_EVENTS_LIST_FAILURE"

export const GET_REVIRWER_COMMENTS = "GET_REVIRWER_COMMENTS";
export const GET_REVIRWER_COMMENTS_FAILURE = "GET_REVIRWER_COMMENTS_FAILURE"

export const GET_MS_DROPDOWNS = "GET_MS_DROPDOWNS";
export const GET_MS_DROPDOWNS_FAILURE = "GET_MS_DROPDOWNS_FAILURE";

export const GET_MS_SITES_DROPDOWNS = "GET_MS_SITES_DROPDOWNS";
export const GET_MS_SITES_DROPDOWNS_FAILURE = "GET_MS_SITES_DROPDOWNS_FAILURE";

export const GET_MS_SUBJECT_COUNTS = "GET_MS_SUBJECT_COUNTS";
export const GET_MS_SUBJECT_COUNTS_FAILURE = "GET_MS_SUBJECT_COUNTS_FAILURE";

export const GET_MS_SUBJECT_LIST = "GET_MS_SUBJECT_LIST";
export const GET_MS_SUBJECT_LIST_FAILURE = "GET_MS_SUBJECT_LIST_FAILURE";

export const GET_MH_SUBJECT_LIST = "GET_MH_SUBJECT_LIST";
export const GET_MH_SUBJECT_LIST_FAILURE = "GET_MH_SUBJECT_LIST_FAILURE";

export const RESET_EVENT_DETAILS = 'RESET_EVENT_DETAILS';
export const RESET_AE_STEPPER_DATA = 'RESET_AE_STEPPER_DATA';
export const RESET_SUBJECT_PROFILE = 'RESET_SUBJECT_PROFILE'

export const GET_EVENT_FLAG = 'GET_EVENT_FLAG'


export const GET_ALL_MEDDRA_CLASSIFICATION_SUCCESS ="GET_ALL_MEDDRA_CLASSIFICATION_SUCCESS";
export const GET_ALL_MEDDRA_CLASSIFICATION_FAILURE ="GET_ALL_MEDDRA_CLASSIFICATION_FAILURE";

export const GET_ALL_WHODD_CLASSIFICATION_SUCCESS ="GET_ALL_WHODD_CLASSIFICATION_SUCCESS"
export const GET_ALL_WHODD_CLASSIFICATION_FAILURE = "GET_ALL_WHODD_CLASSIFICATION_FAILURE"

export const GET_ALL_WHODD_CLASSIFICATION_SUCCESS_1 ="GET_ALL_WHODD_CLASSIFICATION_SUCCESS_1"
export const GET_ALL_WHODD_CLASSIFICATION_FAILURE_1 = "GET_ALL_WHODD_CLASSIFICATION_FAILURE_1"


export const GET_MR_DB_COUNTS = "GET_MR_DB_COUNTS";
export const GET_MR_DB_COUNTS_FAILURE = "GET_MR_DB_COUNTS_FAILURE";

export const GET_SUBJECT_INFORMATION_SUCCESS = "GET_SUBJECT_INFORMATION_SUCCESS";
export const GET_SUBJECT_INFORMATION_FAILURE = "GET_SUBJECT_INFORMATION_FAILURE";


export const GET_MRSUBJECT_LIST_SUCCESS = "GET_MRSUBJECT_LIST_SUCCESS";
export const GET_MRSUBJECT_LIST_FAILURE = "GET_MRSUBJECT_LIST_FAILURE";

export const GET_MRSUBJECT_COUNTS_SUCCESS = "GET_MRSUBJECT_COUNTS_SUCCESS";
export const GET_MRSUBJECT_COUNTS_FAILURE = "GET_MRSUBJECT_COUNTS_FAILURE";

export const GET_MHDB_COUNTS_SUCCESS = "GET_MHDB_COUNTS_SUCCESS";
export const GET_MHDB_COUNTS_FAILURE = "GET_MHDB_COUNTS_FAILURE";

export const GET_MH_STUDIES_SUCCESS = "GET_MH_STUDIES_SUCCESS";
export const GET_MH_STUDIES_FAILURE = "GET_MH_STUDIES_FAILURE";

export const GET_MH_SUBJECT_LIST_COUNTS = "GET_MH_SUBJECT_LIST_COUNTS";
export const GET_MH_SUBJECT_LIST_COUNTS_FAILURE = "GET_MH_SUBJECT_LIST_COUNTS_FAILURE"
export const GET_PMSSUBJECT_COUNTS_SUCCESS ="GET_PMSSUBJECT_COUNTS_SUCCESS";
export const GET_PMSSUBJECT_COUNTS_FAILURE ="GET_PMSSUBJECT_COUNTS_FAILURE";

export const GET_PMSDASHBOARD_CHART_DATA__SUCCESS ="GET_PMSDASHBOARD_CHART_DATA__SUCCESS";
export const GET_PMSDASHBOARD_CHART_DATA_FAILURE ="GET_PMSDASHBOARD_CHART_DATA_FAILURE";

export const GET_ALL_SITES_SUCCESS ="GET_ALL_SITES_SUCCESS";
export const GET_ALL_SITES_FAILURE ="GET_ALL_SITES_FAILURE";


export const GET_PMSSTUDY_DATA_SUCCESS ="GET_PMSSTUDY_DATA_SUCCESS";
export const GET_PMSSTUDY_DATA_FAILURE ="GET_PMSSTUDY_DATA_FAILURE";

export const GET_PMS_STUDY_INFO ="GET_PMS_STUDY_INFO";

export const GET_PMSSUBJECT_LIST ="GET_PMSSUBJECT_LIST";
export const GET_PMSSUBJECT_LIST_FAILURE ="GET_PMSSUBJECT_LIST_FAILURE";

export const GET_PMSSUBJECTDASHBOARD_COUNTS_SUCCESS ="GET_PMSSUBJECTDASHBOARD_COUNTS_SUCCESS";
export const GET_PMSSUBJECTDASHBOARD_COUNTS_FAILURE ="GET_PMSSUBJECTDASHBOARD_COUNTS_FAILURE";
export const GET_PMSSUBJECT_DETAILS_SUCCESS = "GET_PMSSUBJECT_DETAILS_SUCCESS";
export const GET_PMSSUBJECT_DETAILS_FAILURE ="GET_PMSSUBJECT_DETAILS_FAILURE";
export const GET_PMSEVENTSUBJECT_LIST_SUCCESS ="GET_PMSEVENTSUBJECT_LIST_SUCCESS";
export const GET_PMSEVENTSUBJECT_LIST_FAILURE ="GET_PMSEVENTSUBJECT_LIST_FAILURE";

export const GET_PMSEVENT_COMMENTS_SUCCESS ="GET_PMSEVENT_COMMENTS_SUCCESS";
export const GET_PMSEVENT_COMMENTS_FAILURE ="GET_PMSEVENT_COMMENTS_FAILURE";

export const GET_PMSADVERSE_EVENTS_OF_SUBJECT_SUCCESS ="GET_PMSADVERSE_EVENTS_OF_SUBJECT_SUCCESS"
export const GET_PMSADVERSE_EVENTS_OF_SUBJECT_FAILURE ="GET_PMSADVERSE_EVENTS_OF_SUBJECT_FAILURE"

export const GET_PMS_NOTIFICATIONS_SUCCESS = "GET_PMS_NOTIFICATIONS_SUCCESS";
export const GET_PMS_NOTIFICATIONS_FAILURE = "GET_PMS_NOTIFICATIONS_FAILURE";

export const GET_NEWPMSSTUDY_DATA_SUCCESS ="GET_NEWPMSSTUDY_DATA_SUCCESS";
export const GET_NEWPMSSTUDY_DATA_FAILURE = "GET_NEWPMSSTUDY_DATA_FAILURE";

export const GET_CHANGELOGGER_SUCCESS="GET_CHANGELOGGER_SUCCESS";
export const GET_CHANGELOGGER_FAILURE="GET_CHANGELOGGER_FAILURE";

export const GET_AUTDITLOGGER_SUCCESS="GET_AUTDITLOGGER_SUCCESS";
export const GET_AUTDITLOGGER_FAILURE="GET_AUTDITLOGGER_FAILURE";

export const GET_CONCLUDED_DATA_SUCCESS="GET_CONCLUDED_DATA_SUCCESS";
export const GET_CONCLUDED_DATA_FAILURE="GET_CONCLUDED_DATA_FAILURE";

export const resetEventDetails = () => ({
  type: RESET_EVENT_DETAILS,
});

export const resetAEStepperData = () => ({
  type: RESET_AE_STEPPER_DATA,
});

export const resetSubjectProfile = () => ({
  type: RESET_SUBJECT_PROFILE,
});
 

export const getPmsNotifications = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "notifications/fetch_notifications",data)
      .then((response) => {
        dispatch({
          type: GET_PMS_NOTIFICATIONS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PMS_NOTIFICATIONS_FAILURE,
          payload: error,
        });
      });
  };
};

export const getMSSubjectList = (val) => {
  return (dispatch) => {
    axios
      .post(base_url +"marketing-staff/fetch_subjects_list", val)
      .then((res) => {
        res.data.body.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age;
          obj.dose = 'D'+ obj.dose;

          const date = new Date(obj.updatedAt);

          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Asia/Kolkata' 
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);


          obj.lastUpdated = formattedDate
          obj.events = obj.ae_count + obj.sae_count

          const statusMap = {
            [SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT]: 'ON GOING ADVERSE EVENT',
            [SUBJECT_STATUS_ON_STUDY]: 'ON STUDY',
            [SUBJECT_STATUS_OFF_STUDY]: 'CONCLUDED STUDY',
          };

          obj.status = statusMap[obj.status]

        });
        dispatch({
          type: GET_MS_SUBJECT_LIST,
          payload: res.data.body,
        });

      })
      .catch((error) => {
        dispatch({
          type: GET_MS_SUBJECT_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMHSubjectList = (val) => {
  return (dispatch) => {
    
    axios
      .post(base_url +"marketing-head/fetch_subjects", val)
      .then((res) => {
       
        res.data.body.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age;
          obj.dose = 'D'+ obj.dose;

          const date = new Date(obj.updatedAt);

          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Asia/Kolkata' 
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);


          obj.lastUpdated = formattedDate
          obj.events = obj.ae_count + obj.sae_count

          const statusMap = {
            [SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT]: 'ON GOING ADVERSE EVENT',
            [SUBJECT_STATUS_ON_STUDY]: 'ON STUDY',
            [SUBJECT_STATUS_OFF_STUDY]: 'CONCLUDED STUDY',
          };

          obj.status = statusMap[obj.status]

        });
        dispatch({
          type: GET_MH_SUBJECT_LIST,
          payload: res.data.body,
        });

      })
      .catch((error) => {
        dispatch({
          type: GET_MH_SUBJECT_LIST_FAILURE,
          payload: error,
        });
        if(error.response){
        if(error.response.status==403){
          window.isExpired = true;
        }
      }
      });
  };
};

export const getMHStudies = (val) => {
  return (dispatch) => {

    axios
      .post(base_url +"marketing-head/fetch_studies_by_user_id", val)
      .then((res) => {
        
        dispatch({
          type: GET_MH_STUDIES_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MH_STUDIES_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMHDBCounts = (val) => {
  return (dispatch) => {
    axios
      .post(base_url +"marketing-head/fetch_dashboard_data", val)
      .then((res) => {
        dispatch({
          type: GET_MHDB_COUNTS_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MHDB_COUNTS_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const getMSSubjectCounts = (val) => {
  return (dispatch) => {

    axios
      .post(base_url +"marketing-staff/fetch_subjects_counts", val)
      .then((res) => {
        dispatch({
          type: GET_MS_SUBJECT_COUNTS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MS_SUBJECT_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getSubjectInformation = (val) => {
  return (dispatch) => {

    axios
      .post(base_url +"quality-reviewer/fetch_subject_information", {
        "subject_id":val
    })
      .then((res) => {
        let obj = res.data.data[0];
        const dateOfBirth = new Date(obj.date_of_birth);
        const now = new Date();
        const age = now.getFullYear() - dateOfBirth.getFullYear();
        obj.age = age;
        obj.dose = 'D'+ obj.dose;
        dispatch({
          type: GET_SUBJECT_INFORMATION_SUCCESS,
          payload: obj,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_INFORMATION_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMSSitesDropdowns = (val) => {

  return (dispatch) => {
    const jsonList = val?.sites.map(site => ({
      label: site.site_name,
      value: site.site_id
    }));
    dispatch({
      type: GET_MS_SITES_DROPDOWNS,
      payload: jsonList,
    });
  };
};

export const getMSDropdowns = (val) => {
  return (dispatch) => {
    axios
      .post(base_url +"marketing-staff/fetch_dropdown_options", val)
      .then((res) => {
        dispatch({
          type: GET_MS_DROPDOWNS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MS_DROPDOWNS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getReviewerComments = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "comments/fetch_comments_by_event", data)
      .then((response) => {
        dispatch({
          type: GET_REVIRWER_COMMENTS,
          payload: response.data.body,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_REVIRWER_COMMENTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getRejectedEventsList = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "principal-investigator/fetch_rejected_events", data)
      .then((response) => {
        dispatch({
          type: GET_REJECTED_EVENTS_LIST,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_REJECTED_EVENTS_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMarketingStaff = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "marketing-staff/get_all_marketing_staff_details", data)
      .then((response) => {
        
        dispatch({
          type: GET_MARKETING_STAFF_LIST,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MARKETING_STAFF_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMhStudiesSites = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "marketing-head/get_marketing_head_studies_and_sites",data)
      .then((res) => {
        
        dispatch({
          type: GET_MARKETING_HEAD_STUDY_SITES_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MARKETING_HEAD_STUDY_SITES_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMhStudies = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "marketing-head/get_marketing_head_studies",data)
      .then((res) => {
        dispatch({
          type: GET_MARKETING_HEAD_STUDY_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MARKETING_HEAD_STUDY_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const getEventDetails = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_event",{
        "event_id": data.adverse_event_id
    })
      .then((res) => {
        dispatch({
          type: GET_EVENT_DETAILS_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_EVENT_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getSubjectDtls = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/fetch_subject_details",{
        "subject_id" : data.subject_id,
        "dose" : data.dose
    })
      .then((res) => {
        const today = new Date();
        const birthDate = new Date(res.data.body[0]?.date_of_birth);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
      
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
          calculatedAge--;
        }
        res.data.body[0].age = calculatedAge
        dispatch({
          type: GET_SUBJECT_DETAILS_SUCCESS,
          payload: res.data.body[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getMarketingHeads = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "marketing-head/get_all_marketing_heads")
      .then((response) => {
        dispatch({
          type: GET_MARKETING_HEAD_DATA,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MARKETING_HEAD_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getZoneCounts = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "sites/get_counts_by_zone_id",data )
      .then((response) => {
        dispatch({
          type: GET_ZONE_COUNTS_DATA,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ZONE_COUNTS_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const addNewAdverseEvent = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/add_new_adverse_event",data )
      .then((response) => {
        dispatch({
          type: ADD_NEW_ADVERSE_EVENT_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_NEW_ADVERSE_EVENT_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getPiDashboardChartData = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "principal-investigator/dashboard_charts_info",data )
      .then((response) => {
        dispatch({
          type: GET_PIDASHBOARD_CHART_DATA,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PIDASHBOARD_CHART_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const getStudyInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_STUDY_INFO,
      payload: data,
    });
  };
};

export const getMrInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_MR_STUDY_INFO,
      payload: data,
    });
  };
};
export const getQrInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_QR_STUDY_INFO,
      payload: data,
    });
  };
};

export const getPmsInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_PMS_STUDY_INFO,
      payload: data,
    });
  };
};

export const getAdvEventOfSubject = (id, dose) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/get_adverse_events_of_subject",{subject_id:id, dose : dose} )
      .then((response) => {
        dispatch({
          type: GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMHAdvEventOfSubject = (id, dose) => {
  return (dispatch) => {
    axios
      .post(base_url + "marketing-head/get_adverse_events_of_subject",{subject_id:id, dose : dose} )
      .then((response) => {
        
        dispatch({
          type: GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getSubjectCounts = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/fetch_counts", data )
      .then((response) => {
        dispatch({
          type: GET_SUBJECT_COUNTS,
          payload: response.data.body,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getSubjectsRelatedCounts = (id) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_subjects_related_counts", {
        "study_id": id
    } )
      .then((response) => {
        dispatch({
          type: GET_QRSUBJECTS_RELATED_COUNTS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_QRSUBJECTS_RELATED_COUNTS_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getqrdashboardCounts = (id) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_dashboard_counts", {
        "study_id": id
    } )
      .then((response) => {
        dispatch({
          type: GET_QRSUBJECT_COUNTS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_QRSUBJECT_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
// =======================db counts for ms=================
export const getmsdashboardcounts = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/fetch_counts", {
        "study_id": val.studyID,
        "site_id" : val.siteID
    } )
      .then((response) => {
        dispatch({
          type: GET_MSSUBJECT_DB_COUNTS_SUCCESS,
          payload: response.data.body,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MSSUBJECT_DB_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
}


export const getqrdashboardCounts2 = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_dashboard_counts", {
        "study_id": val.studyID,
        "site_id" : val.siteID
    } )
      .then((response) => {
        dispatch({
          type: GET_QRSUBJECT_COUNTS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_QRSUBJECT_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
 
  };
};

export const mrSubjectcounts = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + "medical-reviewer/fetch_counts", {
        "study_id": val
    } )
      .then((response) => {
        dispatch({
          type: GET_MRSUBJECT_COUNTS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MRSUBJECT_COUNTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const getSubjectList = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "subjects/fetch_subjects", data)
      .then((response) => {
        response.data.body.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age;
          obj.dose = 'D'+ obj.dose;

          const date = new Date(obj.updatedAt);

          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Asia/Kolkata' 
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);
          // const formattedTime = date.toLocaleTimeString('en-IN', options);

          obj.lastUpdated = formattedDate
          obj.events = obj.ae_count + obj.sae_count

          const statusMap = {
            [SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT]: 'ON GOING ADVERSE EVENT',
            [SUBJECT_STATUS_ON_STUDY]: 'ON STUDY',
            [SUBJECT_STATUS_OFF_STUDY]: 'CONCLUDED STUDY',
          };

          obj.status = statusMap[obj.status]

        });
        dispatch({
          type: GET_SUBJECT_LIST,
          payload: response.data.body,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};


export const getQrSubjectReviewList = (study_id) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_subjects_list", study_id)
      .then((response) => {

        response.data.data.forEach((obj) => {
       

          const date = new Date(obj.event_createdAt);

          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
             
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);
          obj.event_createdAt = formattedDate
        });

        dispatch({
          type: GET_QRSUBJECT_REVIEW_LIST_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_QRSUBJECT_REVIEW_LIST_FAILURE,
          payload: error,
        });
      });
  };
};
export const getQrSubjectList = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "quality-reviewer/fetch_reported_events", data)
      .then((response) => {


        response.data.data.forEach((obj) => {
       

          const date = new Date(obj.event_createdAt);

          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
             
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);
          obj.event_createdAt = formattedDate
        });

        dispatch({
          type: GET_QRSUBJECT_LIST_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_QRSUBJECT_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMrSubjectList = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "medical-reviewer/fetch_events", data)
      .then((response) => {
        
        response.data.data.forEach((obj) => {
          const date = new Date(obj.event_createdAt);
          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
             
          };

          const formattedDate = date.toLocaleDateString('en-IN', options);
          obj.event_createdAt = formattedDate
        });
        
        dispatch({
          type: GET_MRSUBJECT_LIST_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MRSUBJECT_LIST_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};



export const getActionTakenForAE = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "action-taken-adverse-event-master/get_all_action_taken_adverse_master")
      .then((response) => {
        dispatch({
          type: GET_ACTION_TAKEN_FOR_AE_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ACTION_TAKEN_FOR_AE_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getActionTaken = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "action-taken-master/get_all_actions_taken")
      .then((response) => {
        dispatch({
          type: GET_ACTION_TAKEN_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ACTION_TAKEN_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getSiteAdministration = () => {
  return (dispatch) => {
    axios
      .post(base_url + "anatomical-site-administration-master/get_all_anatomical_site_administrations")
      .then((response) => {
        dispatch({
          type: GET_SITE_ADMINISTRATION,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SITE_ADMINISTRATION_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};



export const getDoseAdministration = () => {
  return (dispatch) => {
    axios
      .post(base_url + "dose-administration-master/get_all_dose_administrations")
      .then((response) => {
        dispatch({
          type: GET_DOSE_ADMINISTRATION,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DOSE_ADMINISTRATION_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getLoginDetails = (data) => {
  return (dispatch) => {
    axios
      .post(base_url + "user-access/user_login",data)
      .then((response) => {
        dispatch({
          type: LOGIN_DATA_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: LOGIN_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getStudyData = () => { // remove this function as it is a duplicate one
  return (dispatch) => {
    axios
      .post(base_url + "study/get_all_studies")
      .then((response) => {
        response.data.data.map(i => {
          i.dose_of_administration = i.da?.dose_administration_name;
          i.anatomical_site_administration =  i.asa?.anatomical_site_administration_name;
          delete i.da
          delete i.asa
        });
        dispatch({
          type: GET_STUDY_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STUDY_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const setRadioValue = (value) => ({
  type: 'SET_RADIO_VALUE',
  payload: value,
});

export const GET_AEBANK_DATA_SUCCESS = 'GET_AEBANK_DATA_SUCCESS';
export const GET_AEBANK_DATA_FAILURE = 'GET_AEBANK_DATA_FAILURE';

export const GET_AEPREVIEW_DATA_SUCCESS = 'GET_AEPREVIEW_DATA_SUCCESS';
export const GET_AEPREVIEW_DATA_FAILURE = 'GET_AEPREVIEW_DATA_FAILURE';

export const CREATE_NEWSTUDY_DATA_SUCCESS = 'CREATE_NEWSTUDY_DATA_SUCCESS';
export const CREATE_NEWSTUDY_DATA_FAILURE = 'CREATE_NEWSTUDY_DATA_FAILURE';

export const GET_AEDVEVENT_BYID_DATA_SUCCESS = 'GET_AEDVEVENT_BYID_DATA_SUCCESS';
export const GET_AEDVEVENT_BYID_DATA_FAILURE = 'GET_AEDVEVENT_BYID_DATA_FAILURE';

export const CREATE_AEBANK_EVENT_DATA_SUCCESS = 'CREATE_AEBANK_EVENT_DATA_SUCCESS';
export const CREATE_AEBANK_EVENT_DATA_FAILURE = 'CREATE_AEBANK_EVENT_DATA_FAILURE';

export const GET_PI_STUDYLIST_DATA_SUCCESS = 'GET_PI_STUDYLIST_DATA_SUCCESS';
export const GET_PI_STUDYLIST_DATA_FAILURE = 'GET_PI_STUDYLIST_DATA_FAILURE';

export const GET_EVENT_CLASSIFICATON_DATA_SUCCESS = 'GET_EVENT_CLASSIFICATON_DATA_SUCCESS';
export const GET_EVENT_CLASSIFICATON_DATA_FAILURE = 'GET_EVENT_CLASSIFICATON__DATA_FAILURE';

export const GET_PI_DETAILS_DATA_FAILURE = 'GET_PI_DETAILS_DATA_FAILURE';
export const GET_PI_DETAILS_DATA_SUCCESS = 'GET_PI_DETAILS_DATA_SUCCESS';

export const GET_STUDY_TITLES_SUCCESS = 'GET_STUDY_TITLES_SUCCESS';
export const GET_STUDY_TITLES_FAILURE = 'GET_STUDY_TITLES_FAILURE';

export const GET_STUDY_ACTIVE_SUCCESS = 'GET_STUDY_ACTIVE_SUCCESS';
export const GET_STUDY_ACTIVE_FAILURE = 'GET_STUDY_ACTIVE_FAILURE';

export const GET_ALL_CAUSALITIES_SUCCESS = 'GET_ALL_CAUSALITIES_SUCCESS';
export const GET_ALL_CAUSALITIES_FAILURE = 'GET_ALL_CAUSALITIES_FAILURE';

export const GET_STUDY_AE_DETAILS_SUCCESS = 'GET_STUDY_AE_DETAILS_SUCCESS';
export const GET_STUDY_AE_DETAILS_FAILURE = 'GET_STUDY_AE_DETAILS_FAILURE';

export const GET_ALL_OUTCOME_SUCCESS = 'GET_ALL_OUTCOME_SUCCESS';
export const GET_ALL_OUTCOME_FAILURE = 'GET_ALL_OUTCOME_FAILURE';

export const GET_SUBJECT_PROFILE_DETAILS_SUCCESS = 'GET_SUBJECT_PROFILE_DETAILS_SUCCESS';
export const GET_SUBJECT_PROFILE_DETAILS_FAILURE = 'GET_SUBJECT_PROFILE_DETAILS_FAILURE';

export const GET_SUBJECT_NUMBER_SUCCESS = 'GET_SUBJECT_NUMBER_SUCCESS';
export const GET_SUBJECT_NUMBER_FAILURE = 'GET_SUBJECT_NUMBER_FAILURE';

export const GET_ALL_SUBJECTS_CURRENT_DOSE_SUCCESS = 'GET_ALL_SUBJECTS_CURRENT_DOSE_SUCCESS';
export const GET_ALL_SUBJECTS_CURRENT_DOSE_FAILURE = 'GET_ALL_SUBJECTS_CURRENT_DOSE_FAILURE';

export const GET_PI_REJ_SUBJECTS_SUCCESS = 'GET_PI_REJ_SUBJECTS_SUCCESS';
export const GET_PI_REJ_SUBJECTS_FAILURE = 'GET_PI_REJ_SUBJECTS_FAILURE';

export const GET_REVIEW_SUBJECT_DETAILS_SUCCESS = 'GET_REVIEW_SUBJECT_DETAILS_SUCCESS';
export const GET_REVIEW_SUBJECT_DETAILS_FAILURE = 'GET_REVIEW_SUBJECT_DETAILS_FAILURE';

export const GET_SERIOUS_ADV_EVENT_SUCCESS = 'GET_SERIOUS_ADV_EVENT_SUCCESS';
export const GET_SERIOUS_ADV_EVENT_FAILURE = 'GET_SERIOUS_ADV_EVENT_FAILURE';

export const GET_REJ_SUBJ_DETAILS_SUCCESS = 'GET_REJ_SUBJ_DETAILS_SUCCESS';
export const GET_REJ_SUBJ_DETAILS_FAILURE = 'GET_REJ_SUBJ_DETAILS_FAILURE';

export const GET_PI_LIST_DATA_SUCCESS = 'GET_PI_LIST_DATA_SUCCESS';
export const GET_PI_LIST_DATA_FAILURE = 'GET_PI_LIST_DATA_FAILURE';

export const GET_QR_LIST_DATA_SUCCESS = 'GET_QR_LIST_DATA_SUCCESS';
export const GET_QR_LIST_DATA_FAILURE = 'GET_QR_LIST_DATA_FAILURE';

export const GET_MR_LIST_DATA_SUCCESS = 'GET_MR_LIST_DATA_SUCCESS';
export const GET_MR_LIST_DATA_FAILURE = 'GET_MR_LIST_DATA_FAILURE';

export const GET_MR_LIST_STUDIES_DATA_SUCCESS = 'GET_MR_LIST_STUDIES_DATA_SUCCESS';
export const GET_MR_LIST_STUDIES_DATA_FAILURE = 'GET_MR_LIST_STUDIES_DATA_FAILURE';

export const GET_QR_LIST_STUDIES_DATA_SUCCESS = 'GET_QR_LIST_STUDIES_DATA_SUCCESS';
export const GET_QR_LIST_STUDIES_DATA_FAILURE = 'GET_QR_LIST_STUDIES_DATA_FAILURE';

export const GET_PI_LIST_STUDIES_DATA_SUCCESS = 'GET_PI_LIST_STUDIES_DATA_SUCCESS';
export const GET_PI_LIST_STUDIES_DATA_FAILURE = 'GET_PI_LIST_STUDIES_DATA_FAILURE';

export const GET_PI_LIST_SITES_DATA_SUCCESS = 'GET_PI_LIST_SITES_DATA_SUCCESS';
export const GET_PI_LIST_SITES_DATA_FAILURE = 'GET_PI_LIST_SITES_DATA_FAILURE';

export const UPDATE_EVENT_DATA_SUCCESS = 'UPDATE_EVENT_DATA_SUCCESS';
export const UPDATE_EVENT_DATA_FAILURE = 'UPDATE_EVENT_DATA_FAILURE';

export const GET_SITES_MH_DATA_SUCCESS = 'GET_SITES_MH_DATA_SUCCESS';
export const GET_SITES_MH_DATA_FAILURE = 'GET_SITES_MH_DATA_FAILURE';

export const GET_PMS_REPORTS_DATA_SUCCESS = 'GET_PMS_REPORTS_DATA_SUCCESS';
export const GET_PMS_REPORTS_DATA_FAILTURE = 'GET_PMS_REPORTS_DATA_FAILTURE';



export const getPiListSites = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/get_all_pi_details_with_their_studies")
        .then((res) => {
          const siteListWithLabel = res.data.data?.map(jsonObj => {
            if(jsonObj.pi_sites.site_name){
              return jsonObj.pi_sites.site_name
            }
            else{
              return ""
            }
          });
          
          // Extract unique zoneIDs using Set
          const uniqueSiteSet = new Set(siteListWithLabel?.map(obj => obj));
          
          // Create a list of JSON objects with unique "value" and "label"
          const uniqueSiteList = [...uniqueSiteSet].map(val => ({
            value: val,
            label: val
          }));
          
          dispatch({
            type: GET_PI_LIST_SITES_DATA_SUCCESS,
            payload: uniqueSiteList,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PI_LIST_SITES_DATA_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        
        });
    };
};


export const getPiListStudies = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/get_all_pi_details_with_their_studies")
        .then((res) => {
          
          const uniqueStudyNamesSet = new Set(
            res.data.data?.flatMap(item => item.pi_studies?.map(study => study.study_name))
          );
          
          
          // Create a list of JSON objects with unique study_name as "value" and "label"
          const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));
          
          dispatch({
            type: GET_PI_LIST_STUDIES_DATA_SUCCESS,
            payload: uniqueStudyNamesList,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PI_LIST_STUDIES_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};

export const getMrListStudies = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "medical-reviewer/get_all_medical_reviewers_details_with_their_studies")
        .then((res) => {
          const uniqueStudyNamesSet = new Set(
            res.data.data?.flatMap(item => item.mr_studies?.map(study => study.study_name))
          );
          
          // Create a list of JSON objects with unique study_name as "value" and "label"
          const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));
          dispatch({
            type: GET_MR_LIST_STUDIES_DATA_SUCCESS,
            payload: uniqueStudyNamesList,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_MR_LIST_STUDIES_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};

export const getMrList = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "medical-reviewer/get_all_medical_reviewers_details_with_their_studies")
        .then((res) => {
          dispatch({
            type: GET_MR_LIST_DATA_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_MR_LIST_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};

export const getQrListStudies = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "quality-reviewer/get_all_quality_reviewers_details_with_their_studies")
        .then((res) => {
          const uniqueStudyNamesSet = new Set(
            res.data.data?.flatMap(item => item.qr_studies?.map(study => study.study_name))
          );
          
          // Create a list of JSON objects with unique study_name as "value" and "label"
          const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));
          dispatch({
            type: GET_QR_LIST_STUDIES_DATA_SUCCESS,
            payload: uniqueStudyNamesList,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_QR_LIST_STUDIES_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};

export const getQrList = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "quality-reviewer/get_all_quality_reviewers_details_with_their_studies")
        .then((res) => {
          dispatch({
            type: GET_QR_LIST_DATA_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_QR_LIST_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};


export const getPiList = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/get_all_pi_details_with_their_studies")
        .then((res) => {
          dispatch({
            type: GET_PI_LIST_DATA_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PI_LIST_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
};


export const getSubjProfDetails = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "subjects/fetch_subject_details",val )
      .then((res) => {  
        const today = new Date();
        const birthDate = new Date(res.data.body[0]?.date_of_birth);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
      
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
          calculatedAge--;
        }
        res.data.body[0].age = calculatedAge
        dispatch({
          type: GET_SUBJECT_PROFILE_DETAILS_SUCCESS,
          payload: res.data.body[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_PROFILE_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getMHSubjProfDetails = (val) => {
  return (dispatch) => {
    
    axios
      .post(base_url + 
        "marketing-head/fetch_subject_details",val )
      .then((res) => {  
        
        const today = new Date();
        const birthDate = new Date(res.data.body[0]?.date_of_birth);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
      
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
          calculatedAge--;
        }
        res.data.body[0].age = calculatedAge
        dispatch({
          type: GET_SUBJECT_PROFILE_DETAILS_SUCCESS,
          payload: res.data.body[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_PROFILE_DETAILS_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getmhsubjectlistcounts = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "marketing-head/get_counts", val)
      .then((res) => {
        dispatch({
          type: GET_MH_SUBJECT_LIST_COUNTS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MH_SUBJECT_LIST_COUNTS_FAILURE,
          payload: error,
        });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
 
export const getReviewSubjDtls = (subjectid) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/get_subject_details", subjectid )
      .then((res) => {
        dispatch({
          type: GET_REVIEW_SUBJECT_DETAILS_SUCCESS,
          payload: res.data.data[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_REVIEW_SUBJECT_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getAllOutComes = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "outcomes-master/get_all_outcomes" )
      .then((res) => {
        dispatch({
          type: GET_ALL_OUTCOME_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_OUTCOME_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getStudyAeDetails = (i) => {
  const case_def = (i.target.options[i.target.selectedIndex].getAttribute('case_def'))
const optionValue = (i.target.options[i.target.selectedIndex].getAttribute('value'))
  if(optionValue)
  return (dispatch) => {
    axios
      .post(base_url + 
        "study/get_study_ae_by_study_aebank_id", {study_aebank_id:optionValue})
      .then((res) => {
        switch(case_def){
          case EVENT_CLASSIFICATION_LEVEL_BRIGHTON:
            res.data.data[0]?.event_meets_case?.map(i =>{
              i.is_selected =false;
              i.is_case_meets =EVENT_MEETS_CASE;
              i.event_description_id=i.study_event_meets_case_id;
            })
            res.data.data[1]?.event_doesnt_meets_case?.map(i =>{
              i.is_selected =false;
              i.is_case_meets =EVENT_DOESNT_MEETS_CASE;
              i.event_description_id=i.study_event_doesnt_meets_case_id;
              
            })
            break;
            case  EVENT_CLASSIFICATION_GRADE_CTCAE:
              res.data.data[0]?.grade_case?.map(i =>{
                i.is_selected =false;
                i.is_case_meets =EVENT_CLASSIFICATION_GRADE_CTCAE;
                i.event_description_id=i.study_ctcae_id;
              })
               break;
               case EVENT_CLASSIFICATION_AESI:
                if (res.data.data[0]) {
                  res.data.data[0].other_case.event_description_id =  res.data.data[0].other_case.study_aesi_description_id;
                }
              
               break;
            
            }
            dispatch({
              type: GET_STUDY_AE_DETAILS_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STUDY_AE_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getStudyAeDetailsSimplified = (i) => {
  const case_def = i.case_def
const optionValue = i.value
  if(optionValue)
  return (dispatch) => {
    axios
      .post(base_url + 
        "study/get_study_ae_by_study_aebank_id", {study_aebank_id:optionValue})
      .then((res) => {
        switch(case_def){
          case EVENT_CLASSIFICATION_LEVEL_BRIGHTON:
            res.data.data[0]?.event_meets_case?.map(i =>{
              i.is_selected =false;
              i.is_case_meets =EVENT_MEETS_CASE;
              i.event_description_id=i.study_event_meets_case_id;
            })
            res.data.data[1]?.event_doesnt_meets_case?.map(i =>{
              i.is_selected =false;
              i.is_case_meets =EVENT_DOESNT_MEETS_CASE;
              i.event_description_id=i.study_event_doesnt_meets_case_id;
              
            })
            break;
            case  EVENT_CLASSIFICATION_GRADE_CTCAE:
              res.data.data[0]?.grade_case?.map(i =>{
                i.is_selected =false;
                i.is_case_meets =EVENT_CLASSIFICATION_GRADE_CTCAE;
                i.event_description_id=i.study_ctcae_id;
              })
               break;
               case EVENT_CLASSIFICATION_AESI:
                if (res.data.data[0]) {
                  res.data.data[0].other_case.event_description_id =  res.data.data[0].other_case.study_aesi_description_id;
                }
              
               break;
            
            }
            dispatch({
              type: GET_STUDY_AE_DETAILS_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STUDY_AE_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getAllCausalities = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "causality-master/get_all_causalities")
      .then((res) => {
        dispatch({
          type: GET_ALL_CAUSALITIES_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_CAUSALITIES_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getSubjectNumber = (val) => {
  return (dispatch) => {
    if(val)
    axios
      .post(base_url + 
        "study/get_subject_sequence_by_study_id",{study_id:val})
      .then((res) => {
        dispatch({
          type: GET_SUBJECT_NUMBER_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SUBJECT_NUMBER_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getStudyTitles = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "study/get_study_ae_titles_by_study_id",{study_id:val})
      .then((res) => {
        dispatch({
          type: GET_STUDY_TITLES_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SERIOUS_ADV_EVENT_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getStudyActive = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "pms-admin/inactivate_study",{study_id:val})
      .then((res) => {
        dispatch({
          type: GET_STUDY_ACTIVE_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STUDY_ACTIVE_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getSAdvEvents = () => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "serious-adverse-event-master/get_all_serious_adverse_events")
      .then((res) => {
        dispatch({
          type: GET_SERIOUS_ADV_EVENT_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SERIOUS_ADV_EVENT_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getAllSubjectsToAddAE = (obj) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "subjects/get_all_subjects_to_add_ae",{pi_id:obj.pi_id,study_id:obj.study_id})
      .then((res) => {
        dispatch({
          type: GET_ALL_SUBJECTS_TO_ADD_AE_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_SUBJECTS_TO_ADD_AE_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getStudyForDose = (obj) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "subjects/get_all_subjects_current_dose",{pi_id:obj.pi_id,study_id:obj.study_id})
      .then((res) => {
        dispatch({
          type: GET_ALL_SUBJECTS_CURRENT_DOSE_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_SUBJECTS_CURRENT_DOSE_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getRejSubDetails = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/rejected_subject_details",{
          "subject_id": val
      })
      .then((res) => {
        res.data.data.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age
        })
        dispatch({
          type: GET_REJ_SUBJ_DETAILS_SUCCESS,
          payload: res.data.data[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_REJ_SUBJ_DETAILS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getPiRejSubject = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/rejected_subjects_list",val)
      .then((res) => {
        res.data.data.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age;
          const date = new Date(obj.createdAt);
          const options = { 
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Asia/Kolkata' 
          };
          const formattedDate = date.toLocaleDateString('en-IN', options);
          obj.lastUpdated = formattedDate
           })
        dispatch({
          type: GET_PI_REJ_SUBJECTS_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PI_REJ_SUBJECTS_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getPIData = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + 
        "principal-investigator/get_principal_investigator",
        {user_id:val})
      .then((res) => {
        dispatch({
          type: GET_PI_DETAILS_DATA_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PI_DETAILS_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getPiStudies = ( ) => {
  return (dispatch) => {
    {localStorage.login_user_id && axios
      .post(base_url + "principal-investigator/get_principal_investigator_studies ",{user_id:localStorage.login_user_id})
      .then((res) => {
        dispatch({
          type: GET_PI_STUDYLIST_DATA_SUCCESS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_EVENT_CLASSIFICATON_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });}
  };
};


export const updateEventbyId = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + "aebank/update_aebank_event_by_id",val)
      .then((response) => {
        
        dispatch({
          type: UPDATE_EVENT_DATA_SUCCESS,
          payload: response.data.data,
        });
        
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_EVENT_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getAllEventClassification = () => {
  return (dispatch) => {
    axios
      .post(base_url + "event-classification-master/get_all_event_classifications")
      .then((response) => {
        dispatch({
          type: GET_EVENT_CLASSIFICATON_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_EVENT_CLASSIFICATON_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const createNewEvent = (value) => {
  return (dispatch) => {
    axios
      .post(base_url + "aebank/create_aebank_event",value)
      .then((response) => {
        dispatch({
          type: CREATE_AEBANK_EVENT_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: CREATE_AEBANK_EVENT_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getEventbyId = (value) => {
  return (dispatch) => {
    axios
      .post(base_url + "aebank/get_ae_bank_event_by_id",value)
      .then((response) => {
        dispatch({
          type: GET_AEDVEVENT_BYID_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_AEDVEVENT_BYID_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const saveNewStudy = (value,studyDoc) => {
  const fd = new FormData();
  for (const key in value) {
    if (key === 'array_of_aebanks') {
        fd.append(key, JSON.stringify(value[key]));
    } else {
        fd.append(key, value[key]);
    }
}
fd.append('file', studyDoc);
  return (dispatch) => {
    axios
      .post(base_url + "study/create_new_study", fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
      .then((response) => {
        response.data.data.i_success=true;
        dispatch({
          type: CREATE_NEWSTUDY_DATA_SUCCESS,
          payload: response.data.data,
        });
        return response;
      })
      .catch((error) => {
        dispatch({
          type: CREATE_NEWSTUDY_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getAEPreview = (value) => {
  return (dispatch) => {
    axios
      .post(base_url + "aebank/get_ae_bank_event_by_id",{
        "aebank_id": value
    })
      .then((response) => {
        dispatch({
          type: GET_AEPREVIEW_DATA_SUCCESS,
          payload: response.data.data[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_AEPREVIEW_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const getZoneData = () => {
  return (dispatch) => {
    axios
      .post(base_url + "zones/get_all_zones")
      .then((response) => {
        dispatch({
          type: GET_ZONE_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ZONE_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getStateData = (val) => {
  return (dispatch) => {
    axios
      .post(base_url + "states/get_states_by_zone", {
        zone_id: val,
      })
      .then((response) => {
        dispatch({
          type: GET_STATE_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STATE_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};

export const getCityData = (val) => {
  if(val != null){
    return (dispatch) => {
      axios
        .post(base_url + "cities/get_cities_by_state", {
          state_id: val,
        })
        .then((response) => {
          dispatch({
            type: GET_CITY_DATA_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_CITY_DATA_FAILURE,
            payload: error,
          });
            if(error.response){
            if(error.response.status==403){
              window.isExpired = true;
            }
          }
        });
    };
  }   
      else {
        return (dispatch) => {
          
              dispatch({
                type: GET_CITY_DATA_SUCCESS,
                payload: null,
              });
        };
      }
};

export const getSiteData = (val) => {
  if(val != null){
  return (dispatch) => {
    axios
      .post(base_url + "sites/get_sites_by_city_id", {
        city_id: val,
      })
      .then((response) => {
        dispatch({
          type: GET_SITE_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SITE_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
    };
  }else{
    return (dispatch) => {
          
      dispatch({
        type: GET_SITE_DATA_SUCCESS,
        payload: null,
      });
};
  }
  };
  export const getAllStudies = () => {
    return (dispatch) => {
      axios
      .post(base_url + "study/get_all_studies")
      .then((response) => {
        response.data.data.map(i => {
  i.dose_of_administration = i.da?.dose_administration_name;
  i.anatomical_site_administration =  i.asa?.anatomical_site_administration_name;
  delete i.da
  delete i.asa
});

          
        dispatch({
          type: GET_STUDIES_DATA_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_STUDIES_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
  };
};
export const allAeBankEvents = () => {
  return (dispatch) => {
    axios
    .post(base_url + "aebank/get_all_ae_bank_events")
    .then((response) => {
      dispatch({
        type: GET_AEBANK_DATA_SUCCESS,
        payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_AEBANK_DATA_FAILURE,
          payload: error,
        });
           if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
      });
    };
  };



  
  export const getQrStudies = ( ) => {
    return (dispatch) => {
      {localStorage.login_user_id && axios
        .post(base_url + "quality-reviewer/get_qr_with_studies_by_user_id ",{user_id:localStorage.login_user_id})
        .then((res) => {
          localStorage.setItem('qr_id', res.data.data[0].qr_id)
          localStorage.setItem('phone_number', res.data.data[0].phone_number)
          dispatch({
            type: GET_QR_STUDYLIST_DATA_SUCCESS,
            payload: res.data.data[0].qr_studies,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_QR_STUDYLIST_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });}
    };
  };

  export const getMrStudies = ( ) => {
    return (dispatch) => {
      axios
        .post(base_url + "medical-reviewer/get_mr_with_studies_by_user_id",{user_id:localStorage.user_id})
        .then((res) => {
           localStorage.setItem('mr_id', res.data.data[0].mr_id)
          dispatch({
            type: GET_MR_STUDYLIST_DATA_SUCCESS,
            payload: res.data.data[0].mr_studies, 
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_MR_STUDYLIST_DATA_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getMrDashboardCounts = (val) => {
    return (dispatch) => {
      axios
        .post(base_url + "medical-reviewer/fetch_dashboard_counts",{study_id:val})
        .then((res) => {
          
          dispatch({
            type: GET_MR_DB_COUNTS,
            payload: res.data.body,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_MR_DB_COUNTS_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };



  export const getQrDashboardStudies = (val) => {
    return (dispatch) => {
      axios
        .post(base_url +"quality-reviewer/dashboard_charts_info", val)
        .then((res) => {
          dispatch({
            type: GET_QRDASHBOARD_LIST_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_QRDASHBOARD_LIST_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getAllWhoddClassificationNew = (value) => {
    return (dispatch) => {
      axios
        .post(base_url +"whodd/fetch_drug_names_based_on_search_term", {search_term: value})
        .then((res) => {
          
          dispatch({
            type: GET_ALL_WHODD_CLASSIFICATION_SUCCESS_1,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_ALL_WHODD_CLASSIFICATION_FAILURE_1,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };
  


  export const getAllWhoddClassification= () => {
    return (dispatch) => {
      axios
        .post(base_url +"masters/fetch_whodd_classifications")
        .then((res) => {
          dispatch({
            type: GET_ALL_WHODD_CLASSIFICATION_SUCCESS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_ALL_WHODD_CLASSIFICATION_FAILURE,
            payload: error,
          });
             if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

 

  export const getMhSitesData = () => {
    return (dispatch) => {
        axios
            .post(base_url + "marketing-head/get_all_pi_sites",{"zone_id": localStorage.getItem("mh_zone_id")})
            
            .then((response) => {
                dispatch({
                    type: GET_SITES_MH_DATA_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_SITES_MH_DATA_FAILURE,
                    payload: error,
                });
                if(error.response){
                  if(error.response.status==403){
                    window.isExpired = true;
                  }
                }
            });
    };
};


  

  export const getPmsdashboardCounts = (id) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/fetch_dashboard_counts", {
          "study_id": id
      } )
        .then((response) => {
          dispatch({
            type: GET_PMSSUBJECT_COUNTS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSSUBJECT_COUNTS_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };
 

  export const getPmsDashboardChartData = (data) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/dashboard_charts_info",{
           "study_id": data
        } )
        .then((response) => {
          dispatch({
            type: GET_PMSDASHBOARD_CHART_DATA__SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSDASHBOARD_CHART_DATA_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getPmsReportsChartData = (data,zone_id,state_id,city_id) => {
    
    return (dispatch) => {
      axios
        .post(base_url + "reports/dashboard_charts_infov2",{
           "study_id": data,
           "zone_id":zone_id ? zone_id: "",
           "state_id":state_id ? state_id: "",
           "city_id":city_id ? city_id:"",
        } )
        .then((response) => {
          dispatch({
            type: GET_PMS_REPORTS_DATA_SUCCESS,
            payload: response.data.data,
          });
         
        })
        .catch((error) => {
          dispatch({
            type: GET_PMS_REPORTS_DATA_FAILTURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getPmsChangerLoggerData = () => {
    
    return (dispatch) => {
      axios
        .post(base_url + "changeLogger/fetch_changelogger_details")
        .then((response) => {
          dispatch({
            type: GET_CHANGELOGGER_SUCCESS,
            payload: response.data.data,
          });
         
        })
        .catch((error) => {
          dispatch({
            type: GET_CHANGELOGGER_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getPmsAuditLoggerData = () => {
    
    return (dispatch) => {
      axios
        .post(base_url + "changeLoggerv2/fetch_changelogger_details")
        .then((response) => {
          dispatch({
            type: GET_AUTDITLOGGER_SUCCESS,
            payload: response.data.data,
          });
         
        })
        .catch((error) => {
          dispatch({
            type: GET_AUTDITLOGGER_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getConcludedData = (data) => {
    
    return (dispatch) => {
      axios
        .post(base_url + "quality-reviewer/fetch_subjects_list_concluded",{
          "study_id": data
       } )
        .then((response) => {
          dispatch({
            type: GET_CONCLUDED_DATA_SUCCESS,
            payload: response.data.data,
          });
         
        })
        .catch((error) => {
          dispatch({
            type: GET_CONCLUDED_DATA_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getAllSites = () => { 
    return (dispatch) => {
      axios
        .post(base_url + "sites/get_all_sites")
        .then((response) => {
          dispatch({
            type: GET_ALL_SITES_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_ALL_SITES_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getPmsStudyData = () => { 
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/get_all_studies")
        .then((response) => {
          response.data.data.map(i => {
            i.dose_of_administration = i.da?.dose_administration_name;
            i.anatomical_site_administration =  i.asa?.anatomical_site_administration_name;
            delete i.da
            delete i.asa
          });

          dispatch({
            type: GET_PMSSTUDY_DATA_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSSTUDY_DATA_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getPmsSubjectList = (data) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/fetch_subjects", {
          "study_id": data
      })
        .then((response) => {
          response.data.body.forEach((obj) => {
            const dateOfBirth = new Date(obj.date_of_birth);
            const now = new Date();
            const age = now.getFullYear() - dateOfBirth.getFullYear();
            obj.age = age;
            obj.dose = 'D'+ obj.dose;
  
            const date = new Date(obj.updatedAt);
  
            const options = { 
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              timeZone: 'Asia/Kolkata' 
            };
  
            const formattedDate = date.toLocaleDateString('en-IN', options);
            // const formattedTime = date.toLocaleTimeString('en-IN', options);
  
            obj.lastUpdated = formattedDate
            obj.events = obj.ae_count + obj.sae_count
  
            const statusMap = {
              [SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT]: 'ON GOING ADVERSE EVENT',
              [SUBJECT_STATUS_ON_STUDY]: 'ON STUDY',
              [SUBJECT_STATUS_OFF_STUDY]: 'CONCLUDED STUDY',
            };
  
            obj.status = statusMap[obj.status]
  
          });
          dispatch({
            type: GET_PMSSUBJECT_LIST,
            payload: response.data.body,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSSUBJECT_LIST_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getPmsSubjectdashboardCounts = (id) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/get_counts", {
          "study_id": id
      } )
        .then((response) => {
          dispatch({
            type: GET_PMSSUBJECTDASHBOARD_COUNTS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSSUBJECTDASHBOARD_COUNTS_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getPmsSubjectDtls = (data) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/fetch_subject_details",data)
        .then((res) => {
          const today = new Date();
          const birthDate = new Date(res.data.body[0]?.date_of_birth);
          let calculatedAge = today.getFullYear() - birthDate.getFullYear();
        
          if (
              today.getMonth() < birthDate.getMonth() ||
              (today.getMonth() === birthDate.getMonth() &&
              today.getDate() < birthDate.getDate())
          ) {
            calculatedAge--;
          }
          res.data.body[0].age = calculatedAge
          dispatch({
            type: GET_PMSSUBJECT_DETAILS_SUCCESS,
            payload: res.data.body[0],
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSSUBJECT_DETAILS_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getPmsEventSubjectList = (data) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/fetch_event",
         {
          "event_id": data
          }
          )
        .then((response) => {
          dispatch({
            type: GET_PMSEVENTSUBJECT_LIST_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSEVENTSUBJECT_LIST_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };

  export const getPmsAdvEventOfSubject = (id, dose) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/get_adverse_events_of_subject",{subject_id:id, dose : dose} )
        .then((response) => {
          dispatch({
            type: GET_PMSADVERSE_EVENTS_OF_SUBJECT_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSADVERSE_EVENTS_OF_SUBJECT_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getPmsEventComments = (data) => {
    return (dispatch) => {
      axios
        .post(base_url + "pms-admin/fetch_comments_by_event", data)
        .then((response) => {
          dispatch({
            type: GET_PMSEVENT_COMMENTS_SUCCESS,
            payload: response.data.body,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_PMSEVENT_COMMENTS_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };


  export const getNewPmsStudyData = () => { 
    return (dispatch) => {
      axios
        .post(base_url + "study/get_all_studies_including_inactive")
        .then((response) => {
        
          response.data.data.map(i => {
            i.dose_of_administration = i.da?.dose_administration_name;
            i.anatomical_site_administration =  i.asa?.anatomical_site_administration_name;
            delete i.da
            delete i.asa
          });

          dispatch({
            type: GET_NEWPMSSTUDY_DATA_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: GET_NEWPMSSTUDY_DATA_FAILURE,
            payload: error,
          });
        if(error.response){
          if(error.response.status==403){
            window.isExpired = true;
          }
        }
        });
    };
  };